import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { brands as staticBrands } from '../data/productData';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import './ProductDetailPage.css';
import { db } from '../firebase/firebase-config';

const getBrandName = (brandId) => {
  return staticBrands.find(b => b.id === brandId)?.name || brandId;
};

const whatsappNumber = "905327233567";

function ProductDetailPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const [showModal, setShowModal] = useState(false);
  const [selectedImageInModal, setSelectedImageInModal] = useState('');

  const [currentImage, setCurrentImage] = useState(''); 

  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, "products", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const productData = { id: docSnap.id, ...docSnap.data() };
          
          // --- BURASI GÜNCELLENDİ (Tek Fotoğraf Kontrolü) ---
          
          if (productData.imageUrls && productData.imageUrls.length > 0) {
            // 1. Yeni sistem (imageUrls dizisi var)
            setCurrentImage(productData.imageUrls[0]);
            
          } else if (productData.imageUrl) {
            // 2. Eski sistem (sadece imageUrl string'i var)
            setCurrentImage(productData.imageUrl);
            // Thumbnail grid'inin > 1 kontrolünü geçmesi için 
            // ve uyumluluk için bu array'i manuel ekliyoruz.
            productData.imageUrls = [productData.imageUrl]; 
            
          } else {
            // 3. Hiç resim yok
            setCurrentImage('https://via.placeholder.com/600?text=Resim+Yok');
            productData.imageUrls = []; // Boş array ata
          }
          
          setProduct(productData); // State'i en son güncelliyoruz
          // --- GÜNCELLEME SONU ---
          
        } else {
          console.log("Böyle bir ürün bulunamadı!");
          setProduct(null);
        }
      } catch (error) {
        console.error("Ürünü çekerken hata:", error);
      }
      setLoading(false);
    };

    fetchProduct();
  }, [id]);

  // Modal'ı açan fonksiyon
  const openImageModal = (imageUrlToDisplay) => {
    setSelectedImageInModal(imageUrlToDisplay);
    setShowModal(true);
  };

  // Modal'ı kapatan fonksiyon
  const closeImageModal = () => {
    setShowModal(false);
    setSelectedImageInModal('');
  };

  // Küçük resme tıklayınca ana resmi değiştiren fonksiyon
  const handleThumbnailClick = (imageUrl) => {
    setCurrentImage(imageUrl);
  };

  // Yükleniyor... ekranı
  if (loading) {
    return (
      <div className="page-loading-container">
        <Navbar />
        <div className="container">Yükleniyor...</div>
        <Footer />
      </div>
    );
  }

  // Ürün bulunamadıysa...
  if (!product) {
    return (
      <div className="page-loading-container">
        <Navbar />
        <div className="container product-not-found">
          <h2>Ürün Bulunamadı</h2>
          <p>Aradığınız ürün kaldırılmış veya böyle bir ürün hiç olmamış olabilir.</p>
          <Link to="/urunler" className="go-back-link">Tüm Ürünlere Dön</Link>
        </div>
        <Footer />
      </div>
    );
  }

  // --- Ürün bulundu, göster ---

  const message = `Merhaba, ${product.name} (SKU: ${product.sku || 'N/A'}) hakkında teklif almak istiyorum.`;
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="product-detail-page">
      <Navbar />

      {/* Ürün içeriği */}
      <div className="container">
        <div className="product-detail-layout">
          
          {/* Sütun 1: Resim Galerisi */}
          <div className="product-detail-image-gallery">
            {/* Ana Resim */}
            <img 
              src={currentImage} // Ana resim her zaman (tekil de olsa) gösterilir
              alt={product.name} 
              className="main-product-image"
              onClick={() => openImageModal(currentImage)}
              style={{ cursor: 'zoom-in' }}
            />
            
            {/* Küçük Resimler (Thumbnails) */}
            {/* --- GÜNCELLENDİ: Sadece 1'den FAZLA resim varsa göster --- */}
            {product.imageUrls && product.imageUrls.length > 1 && (
              <div className="product-thumbnail-grid">
                {product.imageUrls.map((imgUrl, index) => (
                  <img 
                    key={index}
                    src={imgUrl}
                    alt={`${product.name} - Görsel ${index + 1}`}
                    className={`thumbnail-image ${imgUrl === currentImage ? 'active' : ''}`}
                    onClick={() => handleThumbnailClick(imgUrl)}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Sütun 2: Ürün Bilgileri (Aynen kaldı) */}
          <div className="product-detail-info">
            <p className="product-brand-name">{getBrandName(product.brandId)}</p>
            <h1 className="product-title">{product.name}</h1>
            
            <p className="product-price">{product.price ? product.price.toFixed(2) : '0.00'} TL</p>
            
            {/* Teklif Al Butonu */}
            <a 
              href={whatsappUrl} 
              className="whatsapp-offer-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp /> Teklif Al
            </a>

            {/* Teknik Detaylar */}
            <div className="product-specs">
              <h3 className="specs-title">Ürün Detayları</h3>
              <ul>
                <li><strong>SKU (Stok Kodu):</strong> {product.sku || 'Belirtilmemiş'}</li>
                <li><strong>Kategori:</strong> {product.mainCategoryName || 'N/A'}</li>
                {product.subCategoryName && (
                  <li><strong>Alt Kategori:</strong> {product.subCategoryName}</li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Sütun 3: Geniş Açıklama (Layout'un altında) (Aynen kaldı) */}
        <div className="product-full-description">
          <h3>Ürün Açıklaması</h3>
          <p>{product.description || 'Bu ürün için bir açıklama girilmemiş.'}</p>
        </div>
      </div>

      <Footer />

      {/* Resim Modal'ı (Aynen kaldı) */}
      {showModal && (
        <div className="image-modal-overlay" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-button" onClick={closeImageModal}>
              <FaTimes />
            </button>
            <img src={selectedImageInModal} alt={product.name} className="modal-image" />
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductDetailPage;